export function formatPulsePeriodLabel(start: string, end: string): string {
  const s = new Date(start);
  const e = new Date(end);
  e.setDate(e.getDate() - 1);
  const fmt = (d: Date) =>
    d.toLocaleDateString("sv-SE", { day: "numeric", month: "short" });
  return `${fmt(s)} – ${fmt(e)}`;
}
